/* istanbul ignore file */

import { createFrame } from './create-frame';
import { createFrameFromBuffer } from './create-frame-from-buffer';
import { createFrameFromControlCode } from './create-frame-from-control-code';
import { createFrameFromText } from './create-frame-from-text';
import { frameToBuffer } from './frame-to-buffer';

export {
  createFrame,
  createFrameFromBuffer,
  createFrameFromControlCode,
  createFrameFromText,
  frameToBuffer,
};

export type {
  PulseFrame,
  PulseFrameBuildOptions,
  PulseFrameExtensionSupport,
  PulseFrameHeader,
  PulseFrameOpcode,
  PulseFrameOptions,
  PulseFrameError,
} from './types';
